import type { TrackedEmptyStateAction } from './TrackedEmptyState';

export const HOW_PRERENDER_WORKS_HELP: TrackedEmptyStateAction = {
  id: 'watch_how_prerender_works',
  label: 'Watch how Prerender works',
  href: 'https://www.youtube.com/watch?v=OxNt36HhCP4',
};

export const FIRST_THIRTY_DAYS_HELP: TrackedEmptyStateAction = {
  id: 'first_thirty_days_article',
  label: 'What to expect in the first 30 days',
  href: 'https://docs.prerender.io/docs/what-to-expect-first-30-days',
};

export const SERVICE_STATUS_HELP: TrackedEmptyStateAction = {
  id: 'service_status',
  label: 'Check service status',
  href: 'https://docs.prerender.io/docs/keep-track-of-prerender-service-maintenance',
};

export const INTEGRATION_WIZARD_PATH = '/integration-wizard';
export const INTEGRATION_PATH = '/integration';
